var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewSetup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 10.5002H8.66667C9.02029 10.5002 9.35943 10.3597 9.60948 10.1096C9.85952 9.85959 10 9.52045 10 9.16683C10 8.81321 9.85952 8.47407 9.60948 8.22402C9.35943 7.97397 9.02029 7.8335 8.66667 7.8335H6.66667C6.26667 7.8335 5.93333 7.96683 5.73333 8.2335L2 11.8335",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 14.5002L5.73317 13.5668C5.93317 13.3002 6.2665 13.1668 6.6665 13.1668H9.33317C10.0665 13.1668 10.7332 12.9002 11.1998 12.3668L14.2665 9.43351C14.5238 9.1904 14.6739 8.85505 14.6839 8.50123C14.6939 8.14741 14.563 7.80411 14.3198 7.54685C14.0767 7.28959 13.7414 7.13944 13.3875 7.12944C13.0337 7.11944 12.6904 7.2504 12.4332 7.49351L9.63317 10.0935",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 11.1665L5.3335 15.1665",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8.43356C11.7345 8.43356 12.6001 7.56798 12.6001 6.50023C12.6001 5.43248 11.7345 4.56689 10.6667 4.56689C9.59898 4.56689 8.7334 5.43248 8.7334 6.50023C8.7334 7.56798 9.59898 8.43356 10.6667 8.43356Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.8335C5.10457 5.8335 6 4.93807 6 3.8335C6 2.72893 5.10457 1.8335 4 1.8335C2.89543 1.8335 2 2.72893 2 3.8335C2 4.93807 2.89543 5.8335 4 5.8335Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSetup);
export default __webpack_public_path__ + "static/media/viewSetup.0e3f21e0b020a7e4abbb5d97ef9eee88.svg";
export { ForwardRef as ReactComponent };